module.exports = __webpack_public_path__ + "static/other/gameTerraform.4002d3e6.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameTerraform.json
// module id = 2248
// module chunks = 0